import React from "react";
import "./expereince.css";
const Expereince = () => {
  return (
    <div className="my-5 ">
      <h1 className="my-5 work-experience">Work Expereince</h1>
      <div className="d-flex container justify-content-center align-items-center ">
        <div className="table table-responsive">
          <thead>
            <th className="border py-2">Company</th>
            <th className="border py-2">
              Position <br /> Duration
            </th>
            <th className="border py-2">Responsibility</th>
          </thead>
          <tbody>
            <tr>
              <td className="col-1 border  fw-bold">
                <a
                  className="company"
                  href="https://rokomari.com/book;jsessionid=926B5B0C0AE16CF7472A9A33E6591A29"
                >
                  Rokomari dot com
                </a>
              </td>
              <td className="col-1 border text-start">
                Software Engineer <br /> August 2023 - Present
              </td>
              <td className="col-2 border responsibility">
                Planning, Developing and enhancing software and web app
                features. Architected and implemented a complete affiliate
                system, driving significant sales growth.
              </td>
            </tr>
            <tr>
              <td className="col-1 border  fw-bold">
                <a
                  className="company"
                  href="https://www.intellifriend.com/public/home"
                >
                  Intellifriend
                </a>
              </td>
              <td className="col-1 border text-start">
                Sr. Software Engineer <br /> November 2021 - July 2023
              </td>
              <td className="col-2 border responsibility">
                Designed an AI-powered system to track and analyze user PC
                activity for productivity insights. Developed this productivity
                tracking software for Linux and Windows environments.
              </td>
            </tr>
            <tr>
              <td className="col-1 border  fw-bold">
                <a className="company " href="https://www.lifencolor.com">
                  Life n Color
                </a>
              </td>
              <td className="col-1 border text-start">
                Software Engineer <br /> November 2020 - November 2021
              </td>
              <td className="col-2 border responsibility">
                Implemented diverse features to various existing applications,
                enhancing functionality. Utilized advanced data analytics
                techniques to extract actionable insights and strategies.
              </td>
            </tr>
          </tbody>
        </div>
      </div>
    </div>
  );
};

export default Expereince;
